import { xhr } from '@/api/config/Repository'
import UserManagementRepository from '../UserManagementRepository'
import UserSearchRequestDTO from '@/services/administration/models/UserSearchDTO'
import CreateAndUpdateUserRequestDTO from '@/services/administration/models/CreateAndUpdateUserDTO'
export default class UserManagementRepositoryImpl implements UserManagementRepository {
  async getUserSearchData (paramData: UserSearchRequestDTO): Promise<any> {
    const endpoint = 'user/search'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<UserSearchRequestDTO, any>(endpoint, paramData, { headers })
    return {
      content: response.data.data,
      status: response.status,
      totalCount: response.data.totalCount
    }
  }

  async getUserSelectedUserDetails (param: string): Promise<any> {
    const endpoint = `user/viewUserInfo?viewUserName=${param}`
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.get<any>(endpoint, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async updateUserInfo (param: CreateAndUpdateUserRequestDTO): Promise<any> {
    const endpoint = 'user/editUserInfo'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.put<CreateAndUpdateUserRequestDTO, any>(endpoint, param, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }

  async addNewUser (param: CreateAndUpdateUserRequestDTO): Promise<any> {
    const endpoint = 'user/create'
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8'
    }
    const response = await xhr.post<CreateAndUpdateUserRequestDTO, any>(endpoint, param, { headers })
    return {
      content: response.data,
      status: response.status
    }
  }
}
